import { ShippingSettingsRepository } from '@lib/api/repository/shipping-settings/shipping-settings.repository';
import {
  ShippingPackageSettingsInput,
  ShippingServiceSetting,
} from '@lib/types';

export default class ShippingSettingsService {
  constructor(private repository: ShippingSettingsRepository) {}

  get(signal?: AbortSignal) {
    return this.repository.get(signal);
  }

  listAvailable(signal?: AbortSignal) {
    return this.repository.listAvailable(signal);
  }

  replace(services: ShippingServiceSetting[]) {
    return this.repository.replace(services);
  }

  getIntegrationStatus(signal?: AbortSignal) {
    return this.repository.getIntegrationStatus(signal);
  }

  authorizeIntegration(signal?: AbortSignal) {
    return this.repository.authorizeIntegration(signal);
  }

  updatePackageSettings(input: ShippingPackageSettingsInput) {
    return this.repository.updatePackageSettings(input);
  }
}
